<div *ngIf="currentComponent$ | async as currentComponent" class="root">
    <ng-container *transloco="let t; read:'permit'">
        <div class="root__top-bar" [class.root__top-bar--create]="currentComponent === PermitCompononent.Create">
            <a class="root__top-bar__anchor" [routerLink]="['/', PermitPaths.Root]">{{ t("permit") }}</a>
            <div class="root__top-bar__panel-container" [class.root__top-bar__panel-container--create]="currentComponent === PermitCompononent.Create">
                <ng-container *ngIf="(isDemo$ | async) || (details$ | async)?.isDemo">
                    <div class="root__top-bar__panel root__top-bar__demo">{{ t("demo") }}</div>
                </ng-container>
                <ng-container *ngIf="((isPremium$ | async) && !(isDemo$ | async)) || (!(details$ | async)?.isDemo && (details$ | async)?.isPremium)">
                    <div class="root__top-bar__panel root__top-bar__premium">
                        <img class="root__top-bar__premium--icon" src="assets/images/icons/premium-header-icon.svg">
                        <p>{{ t("premium") }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="isBase$ | async">
                    <div class="root__top-bar__panel root__top-bar__base">{{ t("base") }}</div>
                </ng-container>
                <div *ngIf="permitId" class="root__top-bar__panel root__top-bar__permit-id">ID: {{ permitId }}</div>
            </div>
        </div>
    </ng-container>

    <pmt-permit-create class="root__content" [permitId]="permitId" *ngIf="currentComponent === PermitCompononent.Create"></pmt-permit-create>

    <pmt-permit-details class="root__content" [permitId]="permitId" *ngIf="currentComponent === PermitCompononent.Details"></pmt-permit-details>
</div>
